import { useEffect } from 'react';

const useRandomGlowEffect = (selector = '.main-gamer-logo:not(.main-gamer-logo-static)') => {
  useEffect(() => {
    let glowTimeoutId: ReturnType<typeof setTimeout> | undefined;
    let noGlowTimeoutId: ReturnType<typeof setTimeout> | undefined;
    let isEffectActive = false; // Flag para prevenir solapamiento

    const activateGlowEffect = () => {
      if (isEffectActive) return; // No ejecutar si hay un efecto activo
      
      isEffectActive = true;
      const logoElements = document.querySelectorAll(selector);
      
      logoElements.forEach(logo => {
        // Agregar la clase de efecto glow
        logo.classList.add('glow-effect');
        
        // Remover el efecto después de 1 segundo
        setTimeout(() => {
          logo.classList.remove('glow-effect');
          isEffectActive = false;
        }, 1000);
      });
    };

    const activateNoGlowEffect = () => {
      if (isEffectActive) return; // No ejecutar si hay un efecto activo
      
      isEffectActive = true;
      const logoElements = document.querySelectorAll(selector);
      
      logoElements.forEach(logo => {
        // Agregar la clase que quita el sombreado
        logo.classList.add('no-glow-effect');
        
        // Remover el efecto después de 1 segundo
        setTimeout(() => {
          logo.classList.remove('no-glow-effect');
          isEffectActive = false;
        }, 1000);
      });
    };

    const scheduleNextGlow = () => {
      // Generar tiempo aleatorio entre 10-60 segundos (10000-60000 ms)
      const randomTime = Math.random() * (60000 - 10000) + 10000;
      
      glowTimeoutId = setTimeout(() => {
        activateGlowEffect();
        scheduleNextGlow(); // Programar el siguiente
      }, randomTime);
    };

    const scheduleNextNoGlow = () => {
      // Generar tiempo aleatorio entre 10-60 segundos (10000-60000 ms)
      const randomTime = Math.random() * (60000 - 10000) + 10000;
      
      noGlowTimeoutId = setTimeout(() => {
        activateNoGlowEffect();
        scheduleNextNoGlow(); // Programar el siguiente
      }, randomTime);
    };

    // Iniciar ambos ciclos
    scheduleNextGlow();
    scheduleNextNoGlow();

    // Cleanup function
    return () => {
      if (glowTimeoutId) {
        clearTimeout(glowTimeoutId);
      }
      if (noGlowTimeoutId) {
        clearTimeout(noGlowTimeoutId);
      }
    };
  }, [selector]);
};

export default useRandomGlowEffect;